module.exports = __webpack_public_path__ + "static/media/fondo_bailarin.2a95b988.jpg";